
import {distinctUntilChanged, debounceTime} from 'rxjs/operators';
import {AfterViewInit, Component, Input, OnInit, ViewChild} from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import {SelectionModel} from '@angular/cdk/collections';
import {DPBlockedDomain} from '../../shared/domain/bd/dp-blocked-domain.model';
import {DpStatsBlockedDomainsService} from '../dp-stats-blocked-domains.service';
import {GlobalSpinnerService} from '../../shared/components/loader-service/global-spinner.service';
import {SnackBarService} from '../../shared/services/snackbar.service';
import {BlockedDomainStatus, BlockedDomainStatusKL} from '../../shared/domain/bd/blocked-domain-status.enum';
import {Utils} from '../../shared/utils/utils';
import {FormControl} from '@angular/forms';
import {BlocklistAdTracesDialogComponent} from '../../shared/components/domain-specific/blocklist-ad-traces-dialog.component';
import {BlocklistAttachmentsDialogComponent} from '../../shared/components/domain-specific/blocklist-attachments-dialog.component';
import {ActivatedRoute} from '@angular/router';

@Component({
  selector: 'cm-dp-blocklist-table',
  templateUrl: './dp-blocklist-table.component.html',
  styleUrls: ['./dp-blocklist-table.component.scss']
})
export class DpBlocklistTableComponent implements OnInit, AfterViewInit {
   @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;
  selection = new SelectionModel<DPBlockedDomain>(true, []);
  dataSource = new MatTableDataSource<DPBlockedDomain>();

  @Input() mailed = false;

  filter = {
    name: ''
  };
  loadingData = false;
  statusesKL = BlockedDomainStatusKL();

  columns = ['select', 'domain', 'impressions', 'status', 'createDateTime', 'updateDateTime', 'detectionType', 'attachments', 'adTrace', 'comment'];
  searchDomainFormControl = new FormControl();

  constructor(private dpStatsBlockedDomainsService: DpStatsBlockedDomainsService,
              private globalSpinnerService: GlobalSpinnerService,
              private route: ActivatedRoute,
              private matDialog: MatDialog,
              private snackBarService: SnackBarService) {
  }

  ngOnInit() {
    this.mailed = this.route.snapshot.routeConfig.path === 'priority';
    this.refreshDataFirstPage();
  }

  ngAfterViewInit(): void {
    // noinspection TypeScriptUnresolvedFunction
    this.searchDomainFormControl.valueChanges.pipe(
      debounceTime(500),
      distinctUntilChanged(), )
      .subscribe(data => {
        this.filter.name = data;
        this.refreshDataFirstPage();
      });

    this.paginator.length = 0;
    this.paginator.page.subscribe((p: PageEvent) => {
      console.log(p);
      this.refreshData(p.pageIndex, p.pageSize, this.filter ? this.filter.name : '');
    });
  }

  refreshDataFirstPage() {
    this.refreshData(0, this.paginator.pageSize, this.filter.name);
  }

  refreshData(currentPage = 0, pageSize = 10, domain = '') {
    console.log(`refreshData [${currentPage}] [${pageSize}] [${domain}]`);
    this.loadingData = true;
    const route = this.mailed ? this.dpStatsBlockedDomainsService.blockedDomainsMailed(currentPage, pageSize, domain) :
      this.dpStatsBlockedDomainsService.blockedDomains(currentPage, pageSize, domain);
    route.subscribe(next => {
      this.loadingData = false;
      this.selection.clear();
      this.dataSource.data = next.content;
      this.paginator.length = next.totalElements;
    }, () => {
      this.loadingData = false;

    });
  }

  updateDomains(data: DPBlockedDomain[]) {
    this.globalSpinnerService.showLoader();
    this.dpStatsBlockedDomainsService.blockedDomainsUpdate(data).subscribe(next => {
      this.globalSpinnerService.hideLoader();
      this.snackBarService.success('Domains updated');
      this.refreshDataFirstPage();
    }, () => {
      this.snackBarService.error('Error occured');
      this.globalSpinnerService.hideLoader();
    });
  }

  blockAndUpdateStatus() {
    this.selection.selected.forEach(r => r.status = BlockedDomainStatus.BLOCKED);
    this.updateDomains(this.selection.selected);
  }

  updateStatus() {
    this.updateDomains(this.selection.selected);
  }

  updateComment(dpBlockedDomain, comment) {
    this.globalSpinnerService.showLoader();
    this.dpStatsBlockedDomainsService.blockedDomainsUpdate([Object.assign({}, dpBlockedDomain, {
      comment: comment
    })]).subscribe((dpBlockedDomains: DPBlockedDomain[]) => {
      this.globalSpinnerService.hideLoader();
      this.snackBarService.success('Comment updated!');
      if (dpBlockedDomains && dpBlockedDomains.length === 1) {
        dpBlockedDomain.comment = dpBlockedDomains[0].comment;
      }
    }, () => {
      this.globalSpinnerService.hideLoader();
      this.snackBarService.error('Error occured');
    });
  }

  openAdTraceModal(row: DPBlockedDomain) {
    this.matDialog.open(BlocklistAdTracesDialogComponent, <MatDialogConfig> {
      data: {
        dpBlockedDomain: row
      },
      width: '400px'
    });
  }

  openAttachmentsModal(row: DPBlockedDomain) {
    this.matDialog.open(BlocklistAttachmentsDialogComponent, <MatDialogConfig> {
      data: {
        links: row.blockedDomain.links
      },
      width: '400px'
    });
  }

  /** Whether the number of selected elements matches the total number of rows. */
  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSource.data.length;
    return numSelected === numRows;
  }

  /** Selects all rows if they are not all selected; otherwise clear selection. */
  masterToggle() {
    this.isAllSelected() ?
      this.selection.clear() :
      this.dataSource.data.forEach(row => this.selection.select(row));
  }

  exportData() {
    this.globalSpinnerService.showLoader();
    this.dpStatsBlockedDomainsService.blockedDomainsMailedExport(this.filter.name).subscribe(next => {
        this.globalSpinnerService.hideLoader();
        Utils.exportBlobCsv(next, 'blocklist-priority.csv');
      },
      () => {
        this.globalSpinnerService.hideLoader();
      });
  }

}
